
import { StandardEvents } from '@shopify/events';

let cartUpdateSequence = 0;
document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  const sequence = ++cartUpdateSequence;
  try {
    const result = await event.promise;
    if (sequence !== cartUpdateSequence || result?.detail?.didError || result?.userErrors?.length) return;
    const quantity = result?.cart?.totalQuantity;
    if (!Number.isInteger(quantity) || quantity < 0) return;
    document.querySelectorAll('[data-zar-cart-count]').forEach((count) => {
      count.textContent = String(quantity);
    });
    document.querySelectorAll('[data-zar-cart-status]').forEach((status) => {
      status.textContent = status.dataset.countLabel.replace('[count]', String(quantity));
    });
  } catch {}
});
